import { Cookie, SignOut } from "../utils";
import { CALLURL, GUEST, MEETURL } from "../../constants/api_constants";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import axios from "axios";
import { config } from "../constant";
import store from "../store/store";

export class CoreServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CORESERVICE_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static post(data: any, endPoint: any) {
    const url: any = config().CORESERVICE_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CORESERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CORESERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static patchMethod(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CORESERVICE_URL;
    return axios
      .patch(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CORESERVICE_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export class liveChatService {
  public static post(data: any, endPoint: any) {
    const url: any = config().LIVECHATSERVICEURL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          // 'appId': '844239',
          // 'appSecret': 'kU9IPc0C65',
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
}

export class CallServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CALLSERVICE_URL;

    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static post(data: any, endPoint: any) {
    const url: any = config().CALLSERVICE_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CALLSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CALLSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any, data: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CALLSERVICE_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },

        data,
      })
      .then((response: any) => {
        return response;
      });
  }
}

export class MeetGuest{

  public static post(data: any, endPoint: any) {
    const url: any = GUEST;
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
}
export class MeetServices {
  public static get(id:any,endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = MEETURL;

    return axios
      .get(`${url}${endPoint}/${id}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static post(data: any, endPoint: any) {
    const url: any = MEETURL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CALLSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = MEETURL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any, data: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = MEETURL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },

        data,
      })
      .then((response: any) => {
        return response;
      });
  }
}



export class ReportServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().REPORTSERVICE_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static post(data: any, endPoint: any) {
    const url: any =config().REPORTSERVICE_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().REPORTSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().REPORTSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().REPORTSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
}


export class EmailServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().EMAILSERVICE_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static post(data: any, endPoint: any) {
    const url: any = config().EMAILSERVICE_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().EMAILSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().EMAILSERVICE_URL;
    return axios
      .patch(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().EMAILSERVICE_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}
export class TicketServices {
  public static post(data: any, endPoint: any) {
    const url: any = config().TICKETSERVICE_URL;
    const accessToken = "";
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        console.log("errrr ticket", error)
      });
  }
}

export class ConnectorService {

  public static crmPost(payload: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/storeToken`;
    return axios.post(url, payload).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static crmGetModules(connectorId: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/modules/${connectorId}`;
    return axios.get(url).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static crmGetSubMod(modId: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/submodule/${modId}`;
    return axios.get(url).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static crmGetApiDetails(data: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/apiList/${data.conId}/${data.modId}/${data.subModuleId}`;
    return axios.get(url).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static crmUpdatekeywords(data: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/add_keywords`;
    return axios.post(url, data).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static crmGetConfiguredConnectors(domainId: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/list/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static crmGetConnectorsCompanyList(token: any,conn_name:any,domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/${conn_name}/v1/company/${domainId}`;
    const headers = {
      'Authorization': token,
    }
    return axios.get(url, { headers }).then((response: any) => {
      return response.data;
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getCompanySyncList(domainId: any,connId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/innerList/${connId}/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data;
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static crmGetParameters(token: any,con_name:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/${con_name}/v1/parameters`;
    const headers = {
      'Authorization': con_name ==='wix' ?'': token,
    }
    return axios.get(url, { headers }).then((response: any) => 
     {
      return response.data;
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static crmGetCompanyParameters(token: any,con_name:any,com_id:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/${con_name}/v1/company/${com_id}/parameters`;
    const headers = {
        'Authorization': con_name ==='wix' ?'': token,
    }
    return axios.get(url, { headers }).then((response: any) => {
      return response.data;
    }).catch((err) => {
      console.log("err-----", err);
    })
  }

  public static crmCcaasParameters() {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/ccaas_contact_fields`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }

  public static crmSyncContact(payload: any, tokenData: any,con_name:any,end_point:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/${con_name}/v1/${end_point}`;
    let headers = {};
    
    if (con_name === 'xero') {
       headers = {
        'Authorization': tokenData.token,
        'xero-tenant-id' : tokenData?.tenantId
      }
    }
    else {
      headers = {
        'Authorization': tokenData.token,
      }
    }

    return axios.post(url, payload, { headers }).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static getSyncDetails(domainId: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/crm/get_sync_details/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }

  public static async getRefreshToken(domainId: any, token: any,con_name:any) {
    const headers = {
      'Authorization': token
    }
    let url:any;
    if(con_name == 'googlesheet'){
      url = `${config().CONNECTORS_API_BASE_URL}/calendar/v1/${con_name}/refresh_token/${domainId}`;
    }
    else{
      url = `${config().CONNECTORS_API_BASE_URL}/${con_name}/v1/refresh_token/${domainId}`;
    }
    // let url = `${config().CONNECTORS_API_BASE_URL}/${con_name}/v1/refresh_token/${domainId}`;
    return await axios.get(url, { headers }).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getShopifyList(domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/shopify/v1/shopList/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getMagentoList(domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/magento/v1/shopList/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getBigCommerceList(domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/bigcommerce/v1/shopList/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getWixList(domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/wix/v1/shopList/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static getHubspotList(domainId:any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/hubspot/v1/privAppList/${domainId}`;
    return axios.get(url).then((response: any) => {
      return response.data
    }).catch((err) => {
      console.log("err-----", err);
    })
  }
  public static connectShopify(payload: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/connection`;
    return axios.post(url, payload).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }
  public static widgetUpdate(payload: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/shopify/v1/updateBotScript`;
    return axios.post(url, payload).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static connectMagento(payload: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/magento/v1/admin`;
    return axios.post(url, payload).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
    });
  }

  public static get(endPoint: any,token:any) {
    const url: any = `${config().CONNECTORS_API_BASE_URL}/`;
    const headers = {
      'Authorization': token,
    }
    return axios
      .get(`${url}${endPoint}`,{headers})
      .then((response: any) => {
        return response.data;
      });
  }

  public static delete(endPoint: any) {
    const url: any = `${config().CONNECTORS_API_BASE_URL}/`;
    return axios
      .delete(`${url}${endPoint}`)
      .then((response: any) => {
        return response;
      }).catch((err: any) => {
        console.log("err----", err);
      })
  }

  public static async post(endpoint:any, payload:any,  token : any) {
    const url : any =  `${config().CONNECTORS_API_BASE_URL}/`

    let headers = {};
    
    if (payload?.connectorName === 'xero') {
       headers = {
        'Authorization': token,
        'xero-tenant-id' : payload?.connectionName
      }
    }
    else {
      headers = {
        'Authorization': token,
        "Content-Type": "application/json",
      }
    }
 
    return await axios.post(`${url}${endpoint}`,payload, {headers} ).then((respone:any)=>{
      return respone.data;
    }).catch((err:any)=>{
      console.log("err----",err);
    })
  }

  public static xeroGet(endPoint: any,token:any,id:any) {
    const url: any = `${config().CONNECTORS_API_BASE_URL}/`;
    const headers = {
      'Authorization': token,
      'Xero-Tenant-Id':id
    }
    return axios
      .get(`${url}${endPoint}`,{headers})
      .then((response: any) => {
        return response.data;
      });
  }

  public static removeConnection(payload: any) {
    let url = `${config().CONNECTORS_API_BASE_URL}/common/v1/removeConnection`;
    return axios.post(url, payload).then((response: any) => {
      return response.data;
    }).catch((error: any) => {
      console.log("errrr", error);
      return false;
    });
  }

}

export class SmsServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SMSSERVICE_URL;

    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static post(data: any, endPoint: any) {
    const url: any = config().SMSSERVICE_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SMSSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SMSSERVICE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any, data: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SMSSERVICE_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },

        data,
      })
      .then((response: any) => {
        return response;
      });
  }
}

export class SocialmediaServices {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SOCIALMEDIA_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static post(data: any, endPoint: any) {
    const url: any = config().SOCIALMEDIA_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SOCIALMEDIA_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SOCIALMEDIA_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static patchMethod(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SOCIALMEDIA_URL;
    return axios
      .patch(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().SOCIALMEDIA_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export class WhatsappService {
  public static get(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CCAAS_WHATSAPP_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static post(data: any, endPoint: any) {
    const url: any = config().CCAAS_WHATSAPP_URL;
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }
  public static put(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CCAAS_WHATSAPP_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          // SignOut();
        }
      });
  }

  public static patch(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CCAAS_WHATSAPP_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static patchMethod(data: any, endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CCAAS_WHATSAPP_URL;
    return axios
      .patch(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static delete(endPoint: any) {
    //const token: any = Cookie.get();
    const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().CCAAS_WHATSAPP_URL;
    return axios
      .delete(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export class developerAppService {

  public static get(endPoint: any, token: any) {
    const url: any = `${config().DEVELOPER_APP_BASE_URL}/`;
    const headers = {
      'Authorization': token,
    }
    return axios
      .get(`${url}${endPoint}`, { headers })
      .then((response: any) => {
        return response.data;
      });
  }


  public static post(endpoint: any, payload: any, token: any) {
    const url: any = `${config().DEVELOPER_APP_BASE_URL}/`
    const headers = {
      'Authorization': token,
    }
    return axios.post(`${url}${endpoint}`, payload, { headers }).then((respone: any) => {
      return respone.data;
    }).catch((err: any) => {
      console.log("err----", err);
    })
  }

  public static delete(endPoint: any) {
    const url: any = `${config().DEVELOPER_APP_BASE_URL}/`;
    return axios
      .delete(`${url}${endPoint}`)
      .then((response: any) => {
        return response;
      }).catch((err: any) => {
        console.log("err----", err);
      })
  }

}

export class LoggerService {
  public static post(data: any, endPoint: any) {
    const url: any = config().CORESERVICE_URL;
    const accessToken = "";
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        console.log("errrr ticket", error)
      });
  }
}



export const emailotpverification = async (data: any) => {
    try {
        const endPoint = '/email_otp_verification';
        const response = await CoreServices.post(data, endPoint);
        if (response?.data?.statusCode === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const emailOtpVerification= async (data: any) => {
    try {
        const endPoint = '/check_otp_validation';
        const response = await CoreServices.post(data, endPoint);
        if (response?.data?.statusCode === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const updatePassword = async (data: any) => {
    try {
        const endPoint = '/update_password';
        const response = await CoreServices.post(data, endPoint);
        if (response?.data?.statusCode === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const resendOtp = async (data: any) => {
    try {
        const endPoint = '/resend_otp';
        const response = await CoreServices.post(data, endPoint);
        if (response?.data?.statusCode === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log(error);
        return null;
    }
};